import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { NAV, PHONE_1, PHONE_1_TEL } from "@/data/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-shadow duration-300 bg-white/80 backdrop-blur-xl ${
        scrolled ? "border-slate-200 shadow-[0_8px_30px_-12px_rgba(18,58,102,0.25)]" : "border-slate-200/50"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#home" data-testid="header-logo" className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="Sevayog Facilities Pvt Ltd" className="h-12 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-brand-blue transition-colors duration-200 tracking-wide"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={PHONE_1_TEL}
            data-testid="header-call-button"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-brand-blue px-5 py-2.5 text-sm font-bold text-white transition-all duration-200 hover:bg-brand-blueDark hover:-translate-y-0.5"
          >
            <Phone size={15} strokeWidth={2.5} />
            {PHONE_1}
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-slate-700"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white px-6 py-4" data-testid="mobile-menu">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className="block py-3 text-base font-medium text-slate-700 hover:text-brand-blue"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
